import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconHamburgerMenuDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M2 4.188C2 3.532 2.497 3 3.111 3H20.89C21.503 3 22 3.532 22 4.188s-.497 1.187-1.111 1.187H3.11C2.497 5.375 2 4.843 2 4.188M2 12.5c0-.656.497-1.187 1.111-1.187H20.89c.614 0 1.111.531 1.111 1.187s-.497 1.188-1.111 1.188H3.11C2.497 13.688 2 13.156 2 12.5m0 8.313c0-.656.497-1.188 1.111-1.188H20.89c.614 0 1.111.532 1.111 1.188S21.503 22 20.889 22H3.11C2.497 22 2 21.468 2 20.813" clipRule="evenodd" /></svg></>;
}
export default IconHamburgerMenuDefault;